import { Pipe, PipeTransform } from '@angular/core';
import {
  get,
  isObject,
  isString,
  join,
  pick,
  reject,
  toString,
  values,
} from 'lodash';

import { checkString } from '@lockton-apps/shared/util/helpers';

@Pipe({
  name: 'reject',
  standalone: true,
})
export class RejectPipe implements PipeTransform {
  transform<T>(entities: T[] | null, filterString: string, path: string): T[] {
    if (!entities) {
      return [];
    }
    return reject(entities, (entity) => {
      let str = '';

      if (!isObject(entity)) {
        str = toString(entity);
      } else {
        str = isString(path)
          ? get(entity, path)
          : join(values(pick(entity, path)));
      }

      return filterString && checkString(str, filterString);
    }) as T[];
  }
}
